import { render } from "./PaymentTransactionDetails.vue?vue&type=template&id=18b7bd1e&scoped=true"
import script from "./PaymentTransactionDetails.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionDetails.vue?vue&type=script&lang=js"

import "./PaymentTransactionDetails.vue?vue&type=style&index=0&id=18b7bd1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b7bd1e"]])

export default __exports__